
import Metrics from '../../styles/Metrics.js';
import ApplicationStyles from '../../styles/ApplicationStyles';
import { makeStyles } from '@material-ui/core/styles';


export const useStyles = makeStyles(theme =>  ({
    root: {
        height: '100vh',
    },
    paper: {
        margin: theme.spacing(8, 4),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(1),
    },
    submit: {
        margin: theme.spacing(1, 0, 1),
        backgroundColor: '#29317D'
    },
    top: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(2),
    },
    signInButton: {
        float: 'none',
        position: 'static',
        display: 'block',
        margin: 'auto',
        width: '100%',
        justifyContent: 'center',
    },
    switchStyle: {
        marginLeft: '15px',
        fontSize: '16px',
        color: 'rgb(118, 133, 145)',
        fontWeight: '300' 
    },
    textFieldStyle: {
        position: 'relative',
        paddingTop: '15px'
    },
    content: {
        display: 'grid',
        gridTemplateColumns: 'repeat(1,1fr)',
        gridGap: 0,
        height: '100%'
    },
    smallDevice: {
        display: 'initial',
        height:'98%',
        backgroundColor: 'white'
    },
    textFieldStyleRecap: {
        position: 'relative',
        paddingTop: '10px'
    },
    poweredByTic:{
        justifyContent: 'flex-end',
        display: 'flex',
    },
    logo:{
        position: 'absolute',
        zIndex: '1',
        left: '50px',
        top: '50px',
    },
    olas:{
        position: 'absolute',
        zIndex: '1',
        bottom:0,
        height: '14%',
        [theme.breakpoints.down('sm')]: {
            position: 'absolute',
            bottom: '-55em',
            left: '0px',
          }
    },
    dataSmall:{
        flex: 1,
        backgroundColor: '#fff',
        [theme.breakpoints.down('sm')]: {
            
          }
    },
    smallsmall:{
        [theme.breakpoints.down('sm')]: {
            width:'100%'
          },
        [theme.breakpoints.down('xs')]: {
            width:'100%'
          }
    },
    iconStyle:{
        width: '100%',
        height: '100%',
        alignItems: 'center',
        display: 'flex',
        justifyContent: 'center',
    }
}));

export const styles = ({
    ...ApplicationStyles.margins,
    container: {
        display: 'flex',
        flexDirection: 'column',
        height: '90%',
        marginTop: '25px',
        ...ApplicationStyles.margins.baseHorizontalMargin,
        ...ApplicationStyles.margins.smallVerticalMargin
    },
    itemsDiv: {
        marginRight: '16px',
        marginLeft: '16px',
        height: '100%',
    },
    box: {
        display: 'flex',
        flexDirection: 'column',
    },
    head: {
        marginLeft: Metrics.doubleBaseMargin,
        marginRight: Metrics.doubleBaseMargin
    },
    why: {
        justifyContent: 'flex-end'
    },
    list: {
        display: 'flex',
        flexDirection: 'column',
        marginTop: Metrics.tinyMargin,
        marginLeft: Metrics.doubleBaseMargin,
        marginRight: Metrics.doubleBaseMargin
    },
    companyText: {
        fontSize: '0.70em',
        padding: '25px',
    },
    divTicText: {
        textAlign: 'right',
        paddingRight: '5px' 
    },
    divCopyR: {
        borderTop: '1px solid #dedede',
        paddingTop: '2px'
    },
    ticText: {
        fontSize: '1.2em',
        fontWeight: 'bold',
        color: '#233E84'
    },
    imgProp: {
        width: '100%',
        height: '100vh'
    },
    resizeCarousel: {
    }
});